export const SERVER_URL= "https://ecomify-tau.vercel.app";
